import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';
import { useState } from 'react';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {RecordsTable} from "../tables/RecordsTable.tsx";
import { CustomerStatus } from '../types';

export const IndexPage = () => {
    const [statusFilter, setStatusFilter] = useState<CustomerStatus | null>(null);

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader onFilterChange={setStatusFilter} />}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable statusFilter={statusFilter} />
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
